<template>
  <v-app>
    <portal-sysbar></portal-sysbar>
    <div class="main-content">
      <portal-aside></portal-aside>
      <portal-title :title="$t('message.aside.jobplan', { value: 'default' })"></portal-title>
      <portal-breadcumb></portal-breadcumb>
      <div class="content">
        <div class="" justify="center">
          <v-row class="fixed">
            <v-col class="d-flex" cols="12" sm="2">
              <v-autocomplete :items="serialList" :label="$t('message.pageKm.serial', { value: 'default' })"
                item-value="serial" item-text="serial" hide-details="auto" multiple outlined v-model="serials" dense
                @change="filterGroupBySerial">
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0">{{ item.serial }}</span>
                  <span v-if="index === 1" class="grey--text caption">
                    (+{{ serials.length - 1 }} )
                  </span>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col class="d-flex" cols="12" sm="2">
              <v-autocomplete :items="assetList" :label="$t('message.pageKm.loco', { value: 'default' })"
                item-value="asset" item-text="asset" hide-details="auto" multiple outlined dense v-model="assets"
                @change="filterGroupByAsset">
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0">{{ item.assetnum }}</span>
                  <span v-if="index === 1" class="grey--text caption">
                    (+{{ assets.length - 1 }} )
                  </span>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col class="internalUseMsg">
              <strong>*** {{ $t('message.refer', { value: 'default' }) }} ***</strong>

              <v-btn class="ml-4" outlined  color="teal" v-show="!planningView" @click="toggleView()">
                <v-icon>mdi-calendar-month</v-icon> Planning
              </v-btn>
              <v-btn class="ml-4" outlined  color="teal" v-show="planningView" @click="toggleView()">
                <v-icon>mdi-format-list-bulleted</v-icon> Liste
              </v-btn>
            </v-col>
          </v-row>
          <v-row style="padding-top: 30px;">
            <v-col md="2" sm="12" style="overflow: auto;max-height:80vh">
              <v-card class="mx-auto" max-width="500" style=" overflow: auto;" height="100%">

                <v-list>
                  <v-list-item-group v-model="model" mandatory>
                    <v-list-item v-for="item in assetList" :key="item.asset" :value="item.asset"
                      @click="toggle(item.asset)" active-class="portal-deep-blue-bg text--accent-4">
                      <v-list-item-content>
                        <v-list-item-title v-text="item.asset"></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>

              </v-card>
            </v-col>
            <v-col md="10">
              <v-window v-model="window" class="elevation-1" vertical>
                <v-window-item v-for="job in filterdJobPlans" :key="job.asset" :value="job.asset">
                  <job-plan :job="job" :viewMode="planningView"/>
                </v-window-item>
              </v-window>

            </v-col>

          </v-row>
        </div>
        <portal-loading :show="loading"></portal-loading>
      </div>
    </div>
  </v-app>
</template>

<script>
import PortalSysbar from "@/components/PortalSysbar";
import PortalAside from "@/components/PortalAside";
import PortalTitle from "@/components/PortalTitle";
import PortalBreadcumb from "@/components/PortalBreadcumb";
import JobPlan from "@/components/JobPlan";
import PortalLoading from "@/components/PortalLoading.vue";
import { mapActions, mapGetters } from "vuex";
import MaximoService from "@/services/MaximoService";
import {
  getDefaultPeriod,
} from "@/shared/DateHelper";

export default {
  title: "Maintenance Job plan",
  watch: {
    getterCurrentClient: function () {
      this.loadAssets();
    },
  },
  components: {
    PortalSysbar,
    PortalAside,
    PortalTitle,
    PortalBreadcumb,
    JobPlan,
    PortalLoading,
  },
  data() {
    return {
      planningView: false,
      assetList: [],
      serialList: [],
      loading: false,
      jobplans: [],
      filterdJobPlans: [],
      assets: [],
      serials: [],
      window: ''
    };
  },
  methods: {
    ...mapActions("carpet", {
      actionGetAssets: "loadAssets",
    }),

    toggleView(){
      this.planningView = !this.planningView
    },

    async loadAssets() {
      this.loading = true;
      await this.actionGetAssets({
        customer: this.getterCurrentClient,
        start: getDefaultPeriod().start,
        end: getDefaultPeriod().end
      });
      await this.getJobs(this.getterCurrentClient);
      this.initAssetList();
      this.loading = false;
    },

    getJobs(customer) {
      MaximoService.getJobPlans(customer)
        .then((response) => {
          this.jobplans = response.data;
          this.filterdJobPlans = this.jobplans;
        })
        .catch(() => {
          this.jobplans = [];
          this.filterdJobPlans = [];
        });
    },

    initAssetList() {
      this.assetList = this.getterAssets.filter(elt => (elt.leasedState == "leased"));
      this.serialList = this.assetList
    },
    //filter by serial
    filterGroupBySerial() {
      this.filterdJobPlans = this.jobplans;
      let list = this.serials;
      this.assetList = this.getterAssets.filter(elt => (elt.leasedState == "leased"));
      this.assets = [];

      if (list.length > 0) {
        let filterList = this.assetList.filter(function (item) {
          return list.find((filteritem) => filteritem == item.serial);
        });

        this.assetList = filterList
        this.filterdJobPlans = this.filterdJobPlans.filter(function (job) {
          return filterList.find((filteritem) => filteritem.asset == job.asset);
        });
      }

    },
    //filter by asset
    filterGroupByAsset() {
      this.filterdJobPlans = this.jobplans;
      let list = this.assets;
      this.serials = [];
      if (list.length > 0) {
        this.filterdJobPlans = this.filterdJobPlans.filter(function (job) {
          return list.find((filteritem) => filteritem == job.asset);
        });
      }
    },

    toggle(value) {
      this.window = value
    }
  },

  computed: {
    ...mapGetters("carpet", {
      getterAssets: "getAssets",
      getterAgreements: "getAgreements",
    }),

    ...mapGetters("auth", {
      getterCurrentClient: "getCurrentClient",
      getterContact: "getUserContact",
    }),
  },
  mounted() {
    this.loadAssets();
  },
};
</script>

<style scoped>
.fixed {
  position: fixed;
  background-color: #fff;
  z-index: 5;
  right: 70px;
  left: 310px;
  top: 160px;
}

.internalUseMsg {
  display: block;
  margin: auto;
  text-align: right;
  font-style: italic;
}
</style>
